














import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { computed, defineComponent } from '@nuxtjs/composition-api'

import { useClassifiedForm } from '~/compositions/form'
import { formFieldProps } from '~/constants/form'
import { useI18n } from '~/compositions/i18n'

export default defineComponent({
  props: formFieldProps,
  setup(props) {
    const { name } = props

    const { value, valueChanged } = useClassifiedForm(props)
    const { t } = useI18n()

    const icons = {
      info: faInfoCircle
    }

    const popoverText = computed(
      () =>
        `${t('use this option if')} ${t(
          'this vehicle is only available for leasing'
        )
          .toString()
          .toLowerCase()}`
    )

    const handleValueChange = (onlyLeasing: boolean) => {
      valueChanged(name, onlyLeasing)
    }

    return { value, icons, popoverText, handleValueChange }
  }
})
